<div class="position-relative quill-editor-wrapper">
    <quill-editor
    [placeholder]="placeholderText"
    [styles]="customStyles"
    class="content-editor"
    customToolbarPosition="bottom"
    [modules]="quillConfig"
    [sanitize]=true
    [format]="quillModelFormat"
    [formats]="quillFormats"
    (onEditorCreated)="onEditorCreated()"
    (onContentChanged)="onContentChanged($event)"
    theme="snow">

        <div quill-editor-toolbar>
                <tm-emoji-picker (onAddElement)="addEmoji($event)"></tm-emoji-picker>
                <tm-gif-picker (onAddElement)="addGif($event)"></tm-gif-picker>
        </div>
    </quill-editor>
    @if(content?.ops.length > 0){
        <button type="button" aria-label="clear content" class="content-editor-clear-btn"
                (click)="clearContent()">
            <i class="fa fa-times"></i>
        </button> 
    }
</div>